/**
 * Round 17 R3 -- a link to "#obligations" or "#basis" lands on the part
 * of the page it names.
 *
 * React Router changes the hash and leaves the scroll where it was, so
 * every thread step that pointed into a page (the dependency layers,
 * the controls, the basis form) opened its top instead. The target is
 * usually rendered from a query, so it is looked for a few times while
 * the page loads, then given up on quietly.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TRIES = 12;
const EVERY_MS = 250;

export function useScrollToHash(): void {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash || hash.length < 2) return;
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const look = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView?.({ block: "start" });
        return;
      }
      tries += 1;
      if (tries < TRIES) timer = setTimeout(look, EVERY_MS);
    };
    look();
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [pathname, hash]);
}
